import axios, { AxiosInstance } from 'axios';

export const createApi = (config: { BASE_URL: string }): AxiosInstance =>
  axios.create({
    baseURL: config.BASE_URL,
    headers: {
      'Content-type': 'application/json',
    },
  });
